var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "flex justify-center" }, [
    _c(
      "ul",
      { staticClass: "flex gap-x-0.5" },
      [
        _vm.startPage > 1
          ? _c("li", [
              _c("button", {
                staticClass:
                  "w-7 h-7 rounded-full bg-arrow-left text-gray-600 hover:bg-gray-200 transition",
                on: {
                  click: function ($event) {
                    return _vm.onMovePage(_vm.startPage - 1)
                  },
                },
              }),
            ])
          : _vm._e(),
        _vm._l(_vm.viewPages, function (page) {
          return _c("li", { key: page }, [
            _c(
              "button",
              {
                staticClass: "w-7 h-7 rounded-lg transition",
                class: [
                  _vm.pageInfo?.currentPageNum === page
                    ? "bg-blue-400 text-white hover:bg-blue-400"
                    : "text-gray-600 hover:bg-gray-200",
                ],
                on: {
                  click: function ($event) {
                    return _vm.onMovePage(page)
                  },
                },
              },
              [_vm._v(_vm._s(page))]
            ),
          ])
        }),
        _vm.endPage < _vm.pageInfo?.totalPages
          ? _c("li", [
              _c("button", {
                staticClass:
                  "w-7 h-7 rounded-full bg-arrow-right text-gray-600 hover:bg-gray-200 transition",
                on: {
                  click: function ($event) {
                    return _vm.onMovePage(_vm.endPage + 1)
                  },
                },
              }),
            ])
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }